var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "25px",
    viewBox: "0 0 151.33 134.01",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.448 -99.076)",
    fill: "#34495e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-19.783 155.49-75.665 38.781 75.722 38.807 75.606-38.807z",
    opacity: 0.213
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19.783 127.28-75.665 38.781 75.722 38.807 75.606-38.807z",
    opacity: 0.514
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19.783 99.076-75.665 38.781 75.722 38.807 75.606-38.807z",
    opacity: 0.777
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.5d0a4f01abf863ce98e96b052de4ffc3.svg";
export { ForwardRef as ReactComponent };